import { useAuth } from "@/hooks/auth/useAuth";
import { useNotifications } from "@/hooks/useNotifications";
import { Navigate, Outlet } from "react-router-dom";
import { useConversationReaderBroadcast } from "@/hooks/useConversationReaderBroadcast";

const AuthenticatedLayout = () => {
  const { user, loading } = useAuth();

  useNotifications();
  useConversationReaderBroadcast();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <img src="/text-logo.svg" alt="Logo" className="w-2/3 animate-pulse" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="h-dvh bg-background">
      <Outlet />
    </div>
  );
};

export default AuthenticatedLayout;
